export const setItem = (key, value) =>
  !key
    ? console.error("Error: Key is missing")
    : localStorage.setItem(key, JSON.stringify(value));

export const getItem = (key) => {
  if (!key) {
    console.log("Error: Key is missing");
    return null;
  }
  const item = localStorage.getItem(key);
  try {
    return JSON.parse(item);
  } catch (err) {
    // If it's a bare string or malformed JSON, return it as is or sanitized
    if (typeof item === "string") {
      return item.replace(/['"]+/g, "");
    }
    return item;
  }
};

export const removeItem = (key) =>
  key === "" || !key
    ? console.log("Error: Key is missing")
    : localStorage.removeItem(key);
